let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("8LUW6")]).then(() => parcelRequire('1uqxU'));